import axios from "axios";

const baseUrl = process.env.REACT_APP_BACKEND_URL + "api/auth";

const usePasswordReset = () => {
  const requestReset = async (email) => {
    try {
      console.log("Requesting password reset for:", email);
      const response = await axios.post(
        `${baseUrl}/request-password-reset`,
        { email },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log("Password reset request response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error requesting password reset:", error);
      throw error;
    }
  };

  const resetPassword = async (token, password, confirmPassword) => {
    try {
      console.log("Resetting password with token");
      const response = await axios.post(
        `${baseUrl}/reset-password`,
        { token, password, confirmPassword },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log("Password reset response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error resetting password:", error);
      throw error;
    }
  };

  return {
    requestReset,
    resetPassword,
  };
};

export default usePasswordReset;
